// Retention-tab queries (V2 Pipeline Analytics).
// All six queries share the same `filters: StatusLogFiltersInput` shape so
// the Retention tab can mirror the filter wiring used by the Marketing /
// Performance tabs. The names below are the import surface for Agents B and
// C — do not rename without updating those consumers.

export const GET_RETENTION_CURVE = gql`
  query GetRetentionCurve($filters: StatusLogFiltersInput) {
    retentionCurve(filters: $filters) {
      cohortSize
      points {
        day
        retainedPct
        activeCount
      }
    }
  }
`

export const GET_RETENTION_COHORTS = gql`
  query GetRetentionCohorts($filters: StatusLogFiltersInput) {
    retentionCohorts(filters: $filters) {
      rows {
        hireMonth
        cohortSize
        retained30
        retained60
        retained90
        retentionPct30
        retentionPct60
        retentionPct90
        hasFullWindow30
        hasFullWindow60
        hasFullWindow90
      }
    }
  }
`

export const GET_RETENTION_BY_JOB_LISTING = gql`
  query GetRetentionByJobListing($filters: StatusLogFiltersInput) {
    retentionByJobListing(filters: $filters) {
      groupId
      groupLabel
      hires
      retentionPct30
      retentionPct60
      retentionPct90
      cohortSize30
      cohortSize60
      cohortSize90
    }
  }
`

export const GET_RETENTION_BY_RECRUITER = gql`
  query GetRetentionByRecruiter($filters: StatusLogFiltersInput) {
    retentionByRecruiter(filters: $filters) {
      groupId
      groupLabel
      hires
      retentionPct30
      retentionPct60
      retentionPct90
      cohortSize30
      cohortSize60
      cohortSize90
    }
  }
`

export const GET_RETENTION_BY_LEAD_SOURCE = gql`
  query GetRetentionByLeadSource($filters: StatusLogFiltersInput) {
    retentionByLeadSource(filters: $filters) {
      groupId
      groupLabel
      hires
      retentionPct30
      retentionPct60
      retentionPct90
      cohortSize30
      cohortSize60
      cohortSize90
    }
  }
`

export const GET_TERMINATION_REASONS = gql`
  query GetTerminationReasons($filters: StatusLogFiltersInput) {
    terminationReasons(filters: $filters) {
      rows {
        reason
        bucket
        count
      }
      totalTerminated
      voluntaryCount
      involuntaryCount
    }
  }
`
